"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _model = _interopRequireDefault(require("./model"));
function cov_mrdjckzl3() {
  var path = "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/config/lib/reducer.js";
  var hash = "9f8994faa3f726442d55e374b80367882d5f0ac4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/config/lib/reducer.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 34
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 15
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "2": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 51,
          column: 3
        }
      },
      "3": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 49
        }
      },
      "4": {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 21,
          column: 8
        }
      },
      "5": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 55
        }
      },
      "6": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 32,
          column: 8
        }
      },
      "7": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 49
        }
      },
      "8": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 40
        }
      },
      "9": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 88
        }
      },
      "10": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 40
        }
      },
      "11": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 62
        }
      },
      "12": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 47,
          column: 8
        }
      },
      "13": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 15
          },
          end: {
            line: 9,
            column: 16
          }
        },
        loc: {
          start: {
            line: 9,
            column: 69
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 9
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 16
          },
          end: {
            line: 9,
            column: 56
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 9,
            column: 56
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 13,
            column: 33
          }
        }, {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 21,
            column: 8
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 24,
            column: 55
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 32,
            column: 8
          }
        }, {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 36,
            column: 40
          }
        }, {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 39,
            column: 40
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 48,
            column: 5
          }
        }, {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 50,
            column: 19
          }
        }],
        line: 11
      },
      "2": {
        loc: {
          start: {
            line: 31,
            column: 20
          },
          end: {
            line: 31,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 20
          },
          end: {
            line: 31,
            column: 31
          }
        }, {
          start: {
            line: 31,
            column: 35
          },
          end: {
            line: 31,
            column: 56
          }
        }],
        line: 31
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0, 0, 0, 0, 0, 0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9f8994faa3f726442d55e374b80367882d5f0ac4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_mrdjckzl3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_mrdjckzl3();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var configReducerInitialState = (cov_mrdjckzl3().s[0]++, {
  LOADING: false,
  ERROR: false,
  ERROR_CODE: null
});
cov_mrdjckzl3().s[1]++;
var config = function config() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_mrdjckzl3().b[0][0]++, _objectSpread({}, configReducerInitialState));
  var action = arguments.length > 1 ? arguments[1] : undefined;
  cov_mrdjckzl3().f[0]++;
  var newConfig;
  cov_mrdjckzl3().s[2]++;
  switch (action.type) {
    // At initilization or loadSuccess only set loading and error to false
    case 'CONFIG_INITIALIZATION':
      cov_mrdjckzl3().b[1][0]++;
    case 'CONFIG_LOAD_SUCCESS':
      cov_mrdjckzl3().b[1][1]++;
      cov_mrdjckzl3().s[3]++;
      newConfig = _model.default.get(action.data, state);
      cov_mrdjckzl3().s[4]++;
      return _objectSpread(_objectSpread({}, newConfig), {}, {
        LOADING: false,
        ERROR: false,
        ERROR_CODE: null
      });
    case 'CONFIG_BEFORE_LOAD':
      cov_mrdjckzl3().b[1][2]++;
      cov_mrdjckzl3().s[5]++;
      // only set loading to true
      return _objectSpread(_objectSpread({}, state), {}, {
        LOADING: true,
        ERROR: false
      });
    case 'CONFIG_LOAD_ERROR':
      cov_mrdjckzl3().b[1][3]++;
      cov_mrdjckzl3().s[6]++;
      // only set error to true
      return _objectSpread(_objectSpread({}, state), {}, {
        LOADING: true,
        ERROR: true,
        ERROR_CODE: (cov_mrdjckzl3().b[2][0]++, action.data) && (cov_mrdjckzl3().b[2][1]++, action.data.errorCode)
      });
    case 'CONFIG_UPDATE':
      cov_mrdjckzl3().b[1][4]++;
      cov_mrdjckzl3().s[7]++;
      // only adapt the data, but keep the control variables
      newConfig = _model.default.get(action.data, state);
      cov_mrdjckzl3().s[8]++;
      return _objectSpread(_objectSpread({}, state), newConfig);
    case 'GLOBAL_CHANGE_LANGUAGE':
      cov_mrdjckzl3().b[1][5]++;
      cov_mrdjckzl3().s[9]++;
      newConfig = _model.default.changeLanguage(state, action.language, action.defaultLanguage);
      cov_mrdjckzl3().s[10]++;
      return _objectSpread(_objectSpread({}, state), newConfig);
    case 'CSRF_LOAD_SUCCESS':
      cov_mrdjckzl3().b[1][6]++;
      {
        cov_mrdjckzl3().s[11]++;
        newConfig = _model.default.refreshCsrfToken(action.data, state);
        cov_mrdjckzl3().s[12]++;
        return _objectSpread(_objectSpread({}, newConfig), {}, {
          LOADING: false,
          ERROR: false,
          ERROR_CODE: null
        });
      }
    default:
      cov_mrdjckzl3().b[1][7]++;
      cov_mrdjckzl3().s[13]++;
      return state;
  }
};
var _default = exports.default = config;